import { OpeningPaidAddonEnum } from '@src/graphql/generated';

export enum BrandingPackageOptions {
  BASIC = OpeningPaidAddonEnum.BRANDING_BASIC,
  PREMIUM = OpeningPaidAddonEnum.BRANDING_PREMIUM,
}

export interface SelectBrandingPackageProps {
  onSelectPackage: (selected: BrandingPackageOptions) => void;
  priceInEur: number;
  selectedPackage?: BrandingPackageOptions;
}
